






























































































































import { IProductType, PROPERTY_TYPES } from '@resclick/data-access';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@/mixins/table.mixin';
import { Getter } from 'vuex-class';
import moment from 'moment';
import { compass } from '@resclick/compass';
import { Workbook } from 'exceljs';

@Component({
  components: {},
})
export default class HotelsSalesReportShell extends Mixins(TableMixin) {
  @Getter('user/defaultCurrency') currency!: string;
  @Getter('user/ownedPermissions') permissions!: string;

  totals = {
    numberOfRooms: 0,
    numberOfAdults: 0,
    numberOfChildren: 0,
    pax: 0,
    cost: 0,
    price: 0,
    profit: 0,
    profitMargin: 0,
    cancellationInsurance: 0,
    adultOvernight: 0,
    childOvernight: 0,
    roomOvernight: 0,
    cardPurchaseCommission: 0,
    cardSaleCommission: 0,
    // pax: 0,
    // productsCount: 0,
    // ordersCount: 0,
    // turnover: 0,
  };

  updateTotals(data: any = []) {
    const result = {
      numberOfRooms: 0,
      numberOfAdults: 0,
      numberOfChildren: 0,
      pax: 0,
      cost: 0,
      price: 0,
      profit: 0,
      profitMargin: 0,
      currency: '',
      cancellationInsurance: 0,
      adultOvernight: 0,
      childOvernight: 0,
      roomOvernight: 0,
      cardPurchaseCommission: 0,
      cardSaleCommission: 0,
    };

    for (const report of data) {
      result.numberOfRooms += report.rooms;
      result.numberOfAdults += report.adults;
      result.numberOfChildren += report.children;
      result.pax += report.pax;
      result.cost += Number(report.totalCost);
      result.price += Number(report.totalPrice);
      result.currency = report.currency;
      result.cancellationInsurance += Number(report.cancellationInsurancePrice);
      result.adultOvernight += report.adultOvernight;
      result.childOvernight += report.childOvernight;
      result.roomOvernight += report.roomOvernight;
      result.cardPurchaseCommission += Number(report.cardPurchaseCommission);
      result.cardSaleCommission += Number(report.cardSaleCommission);
      result.profit += Number(report.profit);

      result.profitMargin += Number(report.profitMargin);
    }

    result.profitMargin = result.profitMargin / data.length;

    this.totals = result;
  }

  exportLoading = false;

  get columns() {
    const results: any[] = [
      { label: '#', name: 'orderNumber', sortable: true, align: 'center' },

      {
        label: 'GENERAL.CUSTOMER',
        name: 'customer',
        sortable: true,
      },
      {
        label: 'GENERAL.HOTEL',
        name: 'property',
        sortable: true,
      },
      {
        label: 'GENERAL.COMPANY',
        name: 'company',
        sortable: true,
      },
      {
        label: 'GENERAL.BOOKING_DATE',
        name: 'bookingDate',
        sortable: true,
        style: 'width:1px',
        align: 'center',
        field: (row: any) => row.bookingDate && moment(row.bookingDate).format('DD/MM/YYYY HH:mm'),
      },

      {
        label: 'GENERAL.CHECK_IN',
        name: 'checkInDate',
        sortable: true,
        style: 'width:1px',
        align: 'center',
        field: (row: any) => row.checkInDate && moment(row.checkInDate).format('DD/MM/YYYY'),
      },
      {
        label: 'GENERAL.CHECK_OUT',
        name: 'checkOutDate',
        sortable: true,
        style: 'width:1px',
        align: 'center',
        field: (row: any) => row.checkOutDate && moment(row.checkOutDate).format('DD/MM/YYYY'),
      },

      {
        label: 'GENERAL.ROOM',
        name: 'roomTypes',
        sortable: true,
      },
      {
        label: 'GENERAL.NUMBER_OF_ROOMS',
        name: 'rooms',
        sortable: true,
      },
      {
        label: 'GENERAL.NUMBER_OF_ADULTS',
        name: 'adults',
        sortable: true,
      },
      {
        label: 'GENERAL.NUMBER_OF_CHILDREN',
        name: 'children',
        sortable: true,
      },
      {
        label: 'GENERAL.PAX',
        name: 'pax',
        sortable: true,
      },
    ];

    if (this.permissions.includes('VIEW_COST')) {
      results.push({
        label: 'GENERAL.COST',
        name: 'totalCost',
        style: 'width:1px',
        sortable: true,
        // field: (row: any) => `${this.$formatMoney(row.totalCost.value || 0)}`,
      });

      results.push({
        label: 'GENERAL.PROFIT',
        name: 'profit',
        style: 'width:1px; text-align: center',
        sortable: true,
      });

      results.push({
        label: 'GENERAL.PROFIT_MARGIN',
        name: 'profitMargin',
        style: 'width:1px; text-align: center',
        sortable: true,
        field: (row: any) => row.profitMargin + '%',
      });
    }

    results.push(
      ...[
        {
          label: 'GENERAL.SALES_AMOUNT',
          name: 'totalPrice',
          sortable: true,
          align: 'center',
          style: 'width:1px',
        },
        {
          label: 'GENERAL.CURRENCY',
          name: 'currency',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.CANCELLATION_INSURANCE',
          name: 'cancellationInsurancePrice',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.ADULT_OVERNIGHT',
          name: 'adultOvernight',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.CHILD_OVERNIGHT',
          name: 'childOvernight',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.ROOM_OVERNIGHT',
          name: 'roomOvernight',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.AVERAGE_PP_PURCHASE',
          name: 'averagePpPurchase',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.AVERAGE_PP_SALE',
          name: 'averagePpSale',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.CARD_PURCHASE_COMMISSION',
          name: 'cardPurchaseCommission',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
        {
          label: 'GENERAL.CARD_SALE_COMMISSION',
          name: 'cardSaleCommission',
          sortable: true,
          style: 'width:1px',
          align: 'center',
        },
      ],
    );

    return results;
  }

  filters = [
    { label: this.$i18n.t('GENERAL.VOUCHER'), type: 'number', fieldName: 'orderNumber' },
    {
      label: this.$i18n.t('GENERAL.TYPE'),
      type: 'select',
      value: [],
      useChips: true,
      multiple: true,
      fieldName: 'type',
      options: [
        { label: 'New', value: 'NEW' },
        { label: 'Cancel', value: 'CANCEL' },
        { label: 'Change', value: 'CHANGE' },
      ],
    },

    {
      label: this.$i18n.t('GENERAL.BOOKING_DATE'),
      type: 'date-range',
      value: { start: new Date(), end: new Date() },
      fieldName: 'bookingDate',
    },
    { label: this.$i18n.t('GENERAL.CUSTOMER'), type: 'text', value: '', fieldName: 'customerName' },
    { label: this.$i18n.t('GENERAL.HOTEL'), type: 'text', value: '', fieldName: 'hotelName' },
    {
      label: this.$i18n.t('GENERAL.CHECK_IN'),
      type: 'date-range',
      value: { start: '', end: '' },
      fieldName: 'products.checkInDate',
    },
    {
      label: this.$i18n.t('GENERAL.CHECK_OUT'),
      type: 'date-range',
      value: { start: '', end: '' },
      fieldName: 'products.checkOutDate',
    },
    {
      label: this.$i18n.t('GENERAL.COMPANY'),
      type: 'selectDynamic',
      value: [],
      optionName: 'name',
      optionValue: 'id',
      useChips: true,
      multiple: true,
      fieldName: 'company',
      namespace: 'companies',
      action: 'find',
    },

    // { label: this.$i18n.t('GENERAL.AGENT'), type: 'text', value: '', fieldName: 'agentName' },

    /*
    {
      label: this.$i18n.t('GENERAL.ACCOMMODATION_DATE'),
      type: 'date-range',
      value: { start: new Date(), end: new Date('20.12.1987') },
    },
    */
  ];

  get query() {
    return {
      populate: [
        { path: 'company', select: ['name'] },
        { path: 'products.property', select: ['name'] },
        // { path: 'products.room', select: ['displayName'] },
        { path: 'payments' },
        { path: 'balancePayments' },
        { path: 'specialDiscounts' },
      ],
      select: ['+calculations'],
      sort: { orderNumber: 'desc' },
      currency: this.currency,
    };
  }

  getTypeColor(type: string) {
    switch (type) {
      case 'NEW': {
        return 'positive';
      }
      case 'CHANGE': {
        return 'orange';
      }
      case 'CANCEL': {
        return 'negative';
      }
    }
  }

  getPaymentColor(status: string) {
    if (status === 'PENDING') {
      return 'orange';
    } else if (status === 'ACCEPTED') {
      return 'positive';
    } else if (status === 'REJECTED') {
      return 'negative';
    } else {
      return 'primary';
    }
  }

  getProductName(product: IProductType) {
    if (PROPERTY_TYPES.includes(product.type as any)) {
      return (product as any).property?.name;
    }
  }

  @Watch('query.currency')
  onCurrencyChange() {
    this.$nextTick(() => {
      this.$refs.table.refresh();
    });
  }

  async exportData() {
    this.exportLoading = true;
    const queryFilter: any = {};

    this.filters.forEach((f: any) => {
      switch (f.type) {
        case 'date-range':
          if (f.value.start || f.value.end) {
            queryFilter[f.fieldName] = {
              $gte: moment(f.value.start).set({ hour: 0, minute: 0, seconds: 0 }).format('YYYY-MM-DD'),
              $lte: moment(f.value.end).set({ hour: 23, minute: 59, seconds: 59 }),
            };
          }

          return;

        case 'number':
          if (f.value !== '') {
            queryFilter[f.fieldName] = f.value;
          }

          return;

        case 'select':
          if (Array.isArray(f.value) && f.value.length === 0) {
            delete queryFilter[f.fieldName];
          } else {
            queryFilter[f.fieldName] = { $in: f.value };
          }

          return;
        case 'selectDynamic':
          if (Array.isArray(f.value) && f.value.length === 0) {
            delete queryFilter[f.fieldName];
          } else {
            queryFilter[f.fieldName] = { $in: f.value };
          }

          return;
        default:
          queryFilter[f.fieldName] = f.value;
          return;
      }
    });

    const filter = {
      ...queryFilter,
      // @ts-ignore
      ...this.query.filter,
    };

    const { data: orders } = await compass.do('orders', 'excel', {
      filter,
      ...this.query,
    });

    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('orders');

    let columns = [
      { header: 'Voucher', key: 'voucher' },
      { header: 'Type', key: 'type' },
      { header: 'Status', key: 'status' },
      { header: 'Company', key: 'company' },
      { header: 'Agent', key: 'agent' },
      { header: 'Booking Date', key: 'bookingDate' },
      { header: 'Total', key: 'total' },
      { header: 'Currency', key: 'currency' },
      { header: 'Total Cost', key: 'totalCost' },
      { header: 'Total Cost Currency', key: 'totalCostCurrency' },
      { header: 'Confirmation Status', key: 'confirmationStatus' },
      { header: 'Customer', key: 'customer' },
      { header: 'Customer', key: 'customer' },
      { header: 'Sales Amount', key: 'salesAmount' },
      { header: 'Sales Amount Currency', key: 'salesAmountCurrency' },
      { header: 'Remaining Amount', key: 'remainingAmount' },
      { header: 'Remaining Amount Currency', key: 'remainingAmountCurrency' },
      // { header: 'Remaining Collection Amount', key: 'remainingCollectionAmount' },
      // { header: 'Remaining Collection Amount Currency', key: 'remainingCollectionAmountCurrency' },
      {
        header: 'Product Type',
        key: 'productType',
      },
      { header: 'Hotel', key: 'hotel' },
      { header: 'Room', key: 'room' },
      { header: 'Check In', key: 'checkInDate' },
      { header: 'Check Out', key: 'checkOutDate' },
      { header: 'Adults', key: 'adults' },
      { header: 'Children', key: 'children' },
      { header: 'Children Ages', key: 'childrenAges' },
      { header: 'Cost', key: 'cost' },
      { header: 'Cost Currency', key: 'costCurrency' },
      { header: 'Price', key: 'price' },
      { header: 'Price Currency', key: 'priceCurrency' },
      { header: 'Profit', key: 'profit' },
    ];

    worksheet.columns = columns;

    orders.forEach((o: any) => {
      const profitPercent = (o.totalCost / o.total - 1) * -100;

      for (const propertyProduct of o.propertyProducts) {
        o['salesAmount'] = o.calculations.total.value;
        o['salesAmountCurrency'] = o.calculations.total.currency;
        o['remainingAmount'] = o.calculations.remaining.value;
        o['remainingAmountCurrency'] = o.calculations.remaining.currency;
        o['remainingAmount'] = o.calculations.remaining.value;
        o['remainingAmountCurrency'] = o.calculations.remaining.currency;
        // o['remainingCollectionAmount'] = o.calculations.remainingCollection.value;
        // o['remainingCollectionAmountCurrency'] = o.calculations.remainingCollection.currency;

        o[`productType`] = propertyProduct.type;
        o[`hotel`] = propertyProduct.hotel;
        o[`room`] = propertyProduct.roomType;
        o[`checkInDate`] = propertyProduct.checkInDate;
        o[`checkOutDate`] = propertyProduct.checkOutDate;
        o[`adults`] = propertyProduct.adults;
        o[`children`] = propertyProduct.children;
        o[`childrenAges`] = propertyProduct.childrenAges.join(' , ');
        o[`cost`] = propertyProduct.cost;
        o[`costCurrency`] = propertyProduct.costCurrency;
        o[`price`] = propertyProduct.price;
        o[`priceCurrency`] = propertyProduct.priceCurrency;
        o[`profit`] = `${profitPercent.toFixed(2)} %`;

        worksheet.addRow(o);
      }

      for (const cancellationInsuranceProduct of o.cancellationInsuranceProducts) {
        o['salesAmount'] = o.calculations.total.value;
        o['salesAmountCurrency'] = o.calculations.total.currency;
        o['remainingAmount'] = o.calculations.remaining.value;
        o['remainingAmountCurrency'] = o.calculations.remaining.currency;
        o['remainingAmount'] = o.calculations.remaining.value;
        o['remainingAmountCurrency'] = o.calculations.remaining.currency;
        o['remainingCollectionAmount'] = o.calculations.remainingCollection.value;
        o['remainingCollectionAmountCurrency'] = o.calculations.remainingCollection.currency;

        o[`productType`] = cancellationInsuranceProduct.type;
        o[`price`] = cancellationInsuranceProduct.price;
        o[`priceCurrency`] = cancellationInsuranceProduct.priceCurrency;
        o[`profit`] = `${profitPercent.toFixed(2)} %`;

        worksheet.addRow(o);
      }
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const link = document.createElement('a');

    link.href = URL.createObjectURL(
      new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      }),
    );

    link.setAttribute('download', `export-${moment().format('DD-MM-YYYY-HH-mm')}.xlsx`);

    document.body.appendChild(link);

    link.click();
    this.exportLoading = false;
  }

  redirectToPayment(orderId: string, balancePaymentId: string) {
    this.$router.push({
      name: 'payments-with-balance',
      params: { balancePaymentId, id: orderId },
    });
  }

  cleanFilters() {
    this.filters = this.filters.map((f: any) => {
      switch (f.type) {
        case 'number':
          f.value = null;
          return f;
        case 'string':
          f.value = '';
          return f;
        case 'date-range':
          f.value = { start: '', end: '' };
          return f;
        case 'date':
          f.value = { start: '', end: '' };
          return f;
        default:
          return f;
      }
    });
  }
}
